module.exports = __webpack_public_path__ + "img/ic_info2.e393ce0b.jpg";